// Visible in-shell loading indicator — avoids long blank content while page
// data is fetching. Used by CfoInteriorPage and insight card skeletons.
import { Sparkles } from 'lucide-react'

export type CfoPageLoadingProps = {
  label?: string
}

export function CfoPageLoading({ label = 'Loading your CFO data…' }: CfoPageLoadingProps) {
  return (
    <div className="cfo-shell-page-loading" role="status" aria-live="polite" aria-busy="true">
      <span className="cfo-shell-loading-orb" aria-hidden="true">
        <Sparkles size={14} />
      </span>
      <span className="cfo-shell-page-loading-bar" aria-hidden="true" />
      <span className="cfo-shell-page-loading-label">{label}</span>
    </div>
  )
}

export default CfoPageLoading
